/**
 * Consistent button styles across the admin panel.
 * variant: primary | secondary | ghost | danger | outline
 * size: sm | md
 */
const VARIANTS = {
  primary: "bg-brand hover:bg-brand-hover text-white",
  secondary: "bg-surface-2 hover:bg-white/10 text-white border border-border",
  ghost: "text-ink-dim hover:text-white hover:bg-white/5",
  danger: "bg-err/90 hover:bg-err text-white",
  outline: "bg-transparent hover:bg-surface border border-border hover:border-brand hover:text-brand",
};

const SIZES = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
};

export default function Button({
  variant = "primary",
  size = "md",
  icon: Icon,
  children,
  className = "",
  disabled,
  ...props
}) {
  return (
    <button
      {...props}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-md font-medium transition disabled:opacity-50 disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      {Icon && <Icon className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />}
      {children}
    </button>
  );
}

export function IconButton({ icon: Icon, tone = "ghost", title, ...props }) {
  const toneCls = tone === "danger"
    ? "text-ink-dim hover:text-err"
    : tone === "primary"
      ? "text-ink-dim hover:text-brand"
      : tone === "warn"
        ? "text-ink-dim hover:text-warn"
        : "text-ink-dim hover:text-white";
  return (
    <button
      {...props}
      title={title}
      aria-label={title}
      className={`p-1.5 rounded hover:bg-white/5 transition ${toneCls}`}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
